import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Platform, Pressable, View } from 'react-native'

import useAnimatedPress from '@ui/animated/useAnimatedPress'
import Button from '@ui/buttons/Button'
import { ModalBottom } from '@ui/components/Modal'
import TileBlur from '@ui/tiles/TileBlur'
import ChatWindow from '@user/staff/ChatWindow'
import { useRemoteConfig } from 'hooks/useRemoteConfigStore'

export default function ChatSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const config = useRemoteConfig()
  const { t } = useTranslation(['staff'])
  const text = 'staff:panel.sections.chat'

  const [isModalVisible, setModalVisible] = useState(false)

  const onPress = () => {
    setModalVisible(true)
    // router.navigate('/staff/chat')
  }

  if (!config?.region?.meliboChatKey) return null

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/melibo-logo-spaced.png'),
            imageWrapperStyle: {
              width: Platform.select({ default: '45%', web: '55%' }),
              height: Platform.select({ default: '45%', web: '55%' }),
            },
            imageStyle: {
              transform: [{ translateX: -25 }, { translateY: -25 }],
            },
            blur: Platform.select({ default: 125, web: 50 }),
            blurStyle: {
              opacity: 0.75,
              transform: [
                { translateX: 100 },
                { translateY: 200 },
                { scale: 0.75 },
              ],
            },
          }}
          classNameDesc="pr-16"
        />
      </Pressable>
      <ModalBottom
        hideBottomSpace
        open={isModalVisible}
        close={() => setModalVisible(false)}
      >
        <ChatWindow />
      </ModalBottom>
    </>
  )
}
